<template>
  <a-modal
    ref="createModal"
    title="报工-零部件"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <div class="table-page-operator-wrapper">
      <a-button :disabled="selectedRows.length === 0" @click="confirm()" :loading="bglbjLoading" type="primary">保存</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="dispatchId"
      :row-selection="rowSelection"
      :scroll="{ x: 1200}"
    >
      <!-- 报工数量 -->
      <span slot="reportQtySaveTitle">
        <i class="toRequired">*</i>报工数量
      </span>
      <template slot="reportQtySave" slot-scope="text, record">
        <a-input-number v-model="record.reportQtySave" :min="0" @change="reportQtySaveChange(record)" />
      </template>
      <template slot="firstReportingTime" slot-scope="text">
        <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
      </template>
      <template slot="lastReportingTime" slot-scope="text">
        <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiMesDispatchWorkReportingParts } from '@/api/mes/workOrderManage/workOrderSent'
// 表单字段
export default {
  props: {},
  data () {
    return {
      visible: false,
      columns: [
        {
          title: '派工单',
          dataIndex: 'dispatchNumber',
          width: 150
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          width: 150
        },
        {
          title: '序号',
          dataIndex: 'operationSeqNum',
          width: 80
        },
        {
          title: '工序编码',
          dataIndex: 'operationCode',
          width: 120
        },
        {
          title: '工序说明',
          dataIndex: 'operationDesc',
          width: 100,
          ellipsis: true
        },
        {
          title: '派工数量',
          dataIndex: 'requiredQty',
          width: 100
        },
        {
          title: '可报工数量',
          dataIndex: 'waitQty',
          width: 100
        },
        {
          title: '已报工数量',
          dataIndex: 'completedQty',
          width: 100
        },
        {
          // title: '报工数量',
          dataIndex: 'reportQtySave',
          width: 100,
          scopedSlots: { customRender: 'reportQtySave', title: "reportQtySaveTitle" }
        },
        {
          title: '工序类型',
          dataIndex: 'operationTypeName',
          width: 100
        },
        {
          title: '第一次报工时间',
          dataIndex: 'firstReportingTime',
          width: 150,
          scopedSlots: { customRender: 'firstReportingTime' }
        },
        {
          title: '最后一次报工时间',
          dataIndex: 'lastReportingTime',
          width: 150,
          scopedSlots: { customRender: 'lastReportingTime' }
        }
      ],
      typeList: [],
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {},
        type: 'radio'
      },
      bglbjLoading: false
    }
  },
  created () {},
  methods: {
    // 报工数量
    reportQtySaveChange (record) {
      if (record.reportQtySave > record.waitQty) {
        this.$message.warning('报工数量不允许大于可报工数量')
      }
    },
    show (arr) {
      arr.forEach((item, index, array) => {
        if (item.operationTypeName === "串行") {
          if (index === 0) {
            item.waitQty = Number(item.requiredQty) - Number(item.completedQty)
          }
          if (index >= 1) {
            item.waitQty = Number(array[index - 1].completedQty) - Number(array[index].completedQty)
          }
        }
        if (item.operationTypeName === "并行") {
          item.waitQty = Number(item.requiredQty) - Number(item.completedQty)
        }
      });
      this.typeList = arr
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      this.$emit('handle-success')
    },
    // 保存
    confirm () {
      if (Number(this.selectedRows[0].reportQtySave) > Number(this.selectedRows[0].waitReportQty)) {
        this.$message.warning('报工数量不允许大于可报工数量')
        return
      }

      const param = JSON.parse(JSON.stringify(this.selectedRows[0]))
      param.reportQty = param.reportQtySave

      this.bglbjLoading = true
      apiMesDispatchWorkReportingParts(param).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
        } else {
          this.$message.error(response.msg)
        }
        this.bglbjLoading = false
      }).catch(e => {
        this.bglbjLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 600px;
  overflow-y: scroll;
}
</style>
